<script setup>
setPageTitle(PageMeta.Quotes.Add.Title)
definePage({ meta: PageMeta.Quotes.Add.Meta })

import QuotesEditPage from '@/views/Previews/Quotes/QuotesEditPage.vue'

/* ** */
</script>

<template>
  <QuotesEditPage />
</template>
